import { motion, AnimatePresence } from 'framer-motion'
import './LearnMoreModal.css'

interface LearnMoreModalProps {
    isOpen: boolean
    onClose: () => void
    onExecute: () => void
}

export default function LearnMoreModal({ isOpen, onClose, onExecute }: LearnMoreModalProps) {
    if (!isOpen) return null

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="learn-more-modal-overlay" onClick={onClose}>
                    <motion.div
                        className="learn-more-modal glass"
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        transition={{ type: "spring", duration: 0.5, bounce: 0.3 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="modal-close-btn" onClick={onClose}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M18 6L6 18M6 6l12 12" />
                            </svg>
                        </button>

                        <div className="modal-content-wrapper">
                            <header className="modal-header">
                                <h2 className="modal-title">The Settlement Advantage</h2>
                            </header>

                            <div className="modal-section">
                                <h3 className="section-heading">
                                    Maximize Capital Efficiency with Atomic Settlement Infrastructure.
                                </h3>
                                <p className="section-text">
                                    Institutional-grade arbitrage relies on <span className="highlight">Zero-Collateral Settlement Rails</span>. Execute complex settlement logic within a single transaction block, eliminating counterparty risk.
                                </p>
                                <p className="section-text">
                                    Our protocol aggregates deep liquidity pools to provide atomic, uncollateralized USDT for arbitrage execution, liquidations, and collateral swapping. Access liquidity on-demand with sub-200ms propagation delay.
                                </p>

                                <div className="pitch-power">
                                    Atomic Settlement.<br />
                                    <span className="text-neon">SINGLE BLOCK EXECUTION.</span>
                                </div>

                                <p className="pitch-paragraph">
                                    Bypass traditional capital requirements. Leverage algorithmic liquidity to capture fleeting market opportunities with sub-second finality. Your strategy, our liquidity.
                                </p>

                                <div className="pitch-final">
                                    <button className="cta-button" onClick={() => {
                                        onClose()
                                        onExecute()
                                    }}>
                                        Initiate Protocol
                                    </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    )
}
